/**
 * FAQ variant — shared LandingConnectModal controller with variant: "faq".
 */
"use client";

import {
  useLandingConnectModalFormController,
  type UseLandingConnectModalFormControllerOptions,
  type LandingConnectModalFormViewModel,
} from "../../LandingPageConnectModal/controller/useLandingConnectModalFormController";

export type UseFaqLandingFormControllerOptions = Omit<
  UseLandingConnectModalFormControllerOptions,
  "variant"
>;

export function useFaqLandingFormController(
  options: UseFaqLandingFormControllerOptions,
): LandingConnectModalFormViewModel {
  return useLandingConnectModalFormController({
    ...options,
    variant: "faq",
  });
}
